import { atom } from "recoil";

const equipmentItems = atom({

    key:"equipmentItems",
    default: []

});

export default equipmentItems;